import {
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { SessionService } from "./features/http-services/session.service";
import { SharedService } from "./features/http-services/shared.service";
import { ActiveTabService } from "./features/shared/user/services/active-tab.service";
import { ActivityService } from "./features/shared/user/services/activity.service";
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = "xchange-pro";

  @ViewChild("beforeExpired")
  beforeExpired!: TemplateRef<any>;

  @ViewChild("expired")
  expired!: TemplateRef<any>;
  seconds: number | undefined;

  constructor(
    private activityService: ActivityService,
    private sessionService: SessionService,
    private router: Router,
    private activeTabeService: ActiveTabService
  ) {
    // debugger;
    activityService.secondsLeft.subscribe(
      (seconds) => (this.seconds = seconds)
    );
  }
  ngAfterViewInit(): void {
    this.activityService.passTemplate(this.beforeExpired, this.expired);
  }
  continueSession() {
    this.activityService.continueSession();
  }
  endSession() {
    this.activityService.endSession();
  }
  signIn() {
    this.activityService.releaseSessionLock();
    this.sessionService.logout();
  }}
